import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[firstColumnHost]',
})
export class FirstColumnDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
